import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { AnimalHistoricParams } from 'src/domain/animal/AnimalHistoric'

const animalController = new AnimalController()

export function useCreateAnimalHistoric(scope: string = 'createAnimalHistoric') {
  const { userFarm: farmId } = useAuth()

  return useMutation<any, Error, AnimalHistoricParams>({
    mutationKey: [scope],
    mutationFn: (data: AnimalHistoricParams) => animalController.createAnimalHistoric(farmId!, data)
  })
}
